import { render, staticRenderFns } from "./live-request-item.vue?vue&type=template&id=41c9e75b&scoped=true&"
import script from "./live-request-item.vue?vue&type=script&lang=js&"
export * from "./live-request-item.vue?vue&type=script&lang=js&"
import style0 from "./live-request-item.vue?vue&type=style&index=0&id=41c9e75b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9e75b",
  null
  
)

export default component.exports